// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/portable-electronic-devices.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/portable-electronic-devices/ped-overheating-and-battery-fire.js';
import g1 from '../lessons/air-law/portable-electronic-devices/portable-electronic-devices.js';

mount([g0, g1]);
